import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import I18n from 'I18n';
import UISelect from 'UIComponents/input/UISelect';
import { Flex } from 'foundations-components/components/Flex';
import { setDealTableFilter } from '../actions/FiltersActions';
import { FILTERS } from '../constants/FiltersConstants';
import { DEAL_GROUPING_TYPE, DEAL_STAGE } from '../constants/DealGroupingType';
import { getDealGroupingTypeFilter, getDealStageFilter, getForecastCategoryFilter, getPipelineFilter } from '../selectors/filtersSelectors';
import { getForecastCategoryProperty } from '../selectors/properties';
import { filterValidSelectedDealGroupingIds, getDealStageIds, getForecastCategoryIds, makeDealGroupingSelectOptions } from '../utils/dealGroupingUtils';
import { useFetchSpecificPipelineStages } from '../hooks/useFetchSpecificPipelineStages';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DealTableFilters = ({
  ownerId,
  isDetailPage
}) => {
  const dispatch = useDispatch();
  const dealGroupingType = useSelector(getDealGroupingTypeFilter);
  const forecastCategoryProperty = useSelector(getForecastCategoryProperty);
  const selectedDealStages = useSelector(getDealStageFilter);
  const selectedForecastCategories = useSelector(getForecastCategoryFilter);
  const selectedPipelines = useSelector(getPipelineFilter);
  const {
    data: dealStages,
    loading: dealStagesLoading,
    error: dealStagesError
  } = useFetchSpecificPipelineStages(selectedPipelines.first());
  const onHandleSelect = useCallback(({
    target: {
      value
    }
  }) => {
    dispatch(setDealTableFilter(dealGroupingType === DEAL_STAGE ? FILTERS.DEAL_STAGE_GROUPINGS : FILTERS.FORECAST_CATEGORY_GROUPINGS, value, `${ownerId}`, isDetailPage)).catch(() => {
      // should be caught in setDealTableFilter
    });
  }, [dealGroupingType, dispatch, ownerId, isDetailPage]);
  if (!dealStages || !forecastCategoryProperty || dealStagesLoading || dealStagesError || !ownerId) {
    return null;
  }
  const selectOptions = makeDealGroupingSelectOptions({
    dealGroupingType,
    dealStages,
    forecastCategoryProperty
  });

  // filtering here because we can't validate the filters when we sanitize them
  const filteredDealGroupings = filterValidSelectedDealGroupingIds({
    dealGroupingIds: dealGroupingType === DEAL_STAGE ? getDealStageIds(dealStages) : getForecastCategoryIds(forecastCategoryProperty),
    selectedDealGroupings: dealGroupingType === DEAL_STAGE ? selectedDealStages : selectedForecastCategories
  });

  // Generates label - e.g. "All deal stages," "All forecast categories," etc
  const ButtonContent = () => {
    var _forecastCategoryProp;
    const totalItems = dealGroupingType === DEAL_STAGE ? dealStages.length : forecastCategoryProperty === null || forecastCategoryProperty === void 0 || (_forecastCategoryProp = forecastCategoryProperty.options) === null || _forecastCategoryProp === void 0 ? void 0 : _forecastCategoryProp.length;

    // Case: 0 or all items selected
    if (filteredDealGroupings.length === totalItems || !filteredDealGroupings.length) {
      return DEAL_GROUPING_TYPE[dealGroupingType].allSelectedText;
    }

    // Case: Some items selected
    return DEAL_GROUPING_TYPE[dealGroupingType].filterCountSelectedText(filteredDealGroupings.length);
  };
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "start",
    marginBlockEnd: "400",
    children: [DEAL_GROUPING_TYPE[dealGroupingType].filterLabelText, /*#__PURE__*/_jsx(UISelect, {
      anchorType: "button",
      "aria-labelledby": "rep-filter-forecastCategory-label",
      ButtonContent: ButtonContent,
      buttonUse: "transparent",
      "data-selenium-test": "rep-filter-forecastCategory",
      menuWidth: "auto",
      multi: true,
      onChange: onHandleSelect,
      options: [{
        text: I18n.text(DEAL_GROUPING_TYPE[dealGroupingType].allSelectedText.props.message),
        selectAll: true,
        options: selectOptions
      } // as any needed for selectAll - soon to be replaced in Trellis migration
      ]
      // Placeholder should never be visible, but is required in UISelect
      ,
      placeholder: I18n.text('repOverviewTable.filters.categoryOrStagePlaceholder'),
      value: filteredDealGroupings
    })]
  });
};
export default DealTableFilters;